<template>
	<div>
		<!-- Underwriter -->
		<case-form :isBoxed="false" :schema="schemaUnderwriter" />

		<!-- Country of risk -->
		<case-form
			:isBoxed="false"
			:schema="[
				{
					label: 'Country of risk domicile',
					component: 'select',
					bindTo: 'case.facts.countryOfRiskDomicile',
					props: {
						options: this.countries
					}
				}
			]"
		/>

		<!-- Producer -->
		<div class="xs-12 fs4 fw7 mb1 mt6">Producer</div>
		<berkley-commission />

		<!-- Owner -->
		<div class="xs-12 fs4 fw7 mb2 mt6">Policy Owner</div>
		<case-form :schema="schemaHolder" />

		<!-- Insured -->
		<div class="xs-12 fs4 fw7 mb2 mt6">Insured</div>
		<case-form :schema="schemaInsured" />

		<!-- Turnovers + benefits -->
		<products-liability-turnovers />

		<!-- Offer fields -->
		<offer-form :schema="schemaOffer" :isBoxed="false" class="mt6" />

		<!-- Subjectivity -->
		<case-form :schema="schemaSubjectivity" class="mt6" />
	</div>
</template>

<script>
import CaseForm from "../CaseForm/CaseForm.vue"
import OfferForm from "./OfferForm.vue"
import BerkleyCommission from "../mockedBerkley/BerkleyCommission"
import BerkleyNatureOfBusinessSelect from "./BerkleyNatureOfBusinessSelect.vue"
import BerkleyNaicSelect from "./BerkleyNaicSelect.vue"
import BerkleyUnderwriter from "./BerkleyUnderwriter.vue"
import ProductsLiabilityTurnovers from "./ProductsLiabilityTurnovers"
import dayjs from "dayjs"

export default {
	components: {
		CaseForm,
		OfferForm,
		BerkleyCommission,
		ProductsLiabilityTurnovers
	},

	data() {
		return {
			countries: [
				{ name: "Afghanistan", value: "Afghanistan" },
				{ name: "Åland Islands", value: "Åland Islands" },
				{ name: "Albania", value: "Albania" },
				{ name: "Algeria", value: "Algeria" },
				{ name: "American Samoa", value: "American Samoa" },
				{ name: "Andorra", value: "Andorra" },
				{ name: "Angola", value: "Angola" },
				{ name: "Anguilla", value: "Anguilla" },
				{ name: "Antarctica", value: "Antarctica" },
				{
					name: "Antigua & Barbuda",
					value: "Antigua & Barbuda"
				},
				{ name: "Argentina", value: "Argentina" },
				{ name: "Armenia", value: "Armenia" },
				{ name: "Aruba", value: "Aruba" },
				{ name: "Australia", value: "Australia" },
				{ name: "Austria", value: "Austria" },
				{ name: "Azerbaijan", value: "Azerbaijan" },
				{ name: "Bahamas", value: "Bahamas" },
				{ name: "Bahrain", value: "Bahrain" },
				{ name: "Bangladesh", value: "Bangladesh" },
				{ name: "Barbados", value: "Barbados" },
				{ name: "Belarus", value: "Belarus" },
				{ name: "Belgium", value: "Belgium" },
				{ name: "Belize", value: "Belize" },
				{ name: "Benin", value: "Benin" },
				{ name: "Bermuda", value: "Bermuda" },
				{ name: "Bhutan", value: "Bhutan" },
				{ name: "Bolivia", value: "Bolivia" },
				{
					name: "Bosnia & Herzegovina",
					value: "Bosnia & Herzegovina"
				},
				{ name: "Botswana", value: "Botswana" },
				{ name: "Brazil", value: "Brazil" },
				{
					name: "British Indian Ocean Territory",
					value: "British Indian Ocean Territory"
				},
				{
					name: "British Virgin Islands",
					value: "British Virgin Islands"
				},
				{ name: "Brunei", value: "Brunei" },
				{ name: "Bulgaria", value: "Bulgaria" },
				{ name: "Burkina Faso", value: "Burkina Faso" },
				{ name: "Burundi", value: "Burundi" },
				{ name: "Cambodia", value: "Cambodia" },
				{ name: "Cameroon", value: "Cameroon" },
				{ name: "Canada", value: "Canada" },
				{ name: "Cape Verde", value: "Cape Verde" },
				{
					name: "Caribbean Netherlands",
					value: "Caribbean Netherlands"
				},
				{ name: "Cayman Islands", value: "Cayman Islands" },
				{
					name: "Central African Republic",
					value: "Central African Republic"
				},
				{ name: "Chad", value: "Chad" },
				{ name: "Chile", value: "Chile" },
				{ name: "China", value: "China" },
				{
					name: "Christmas Island",
					value: "Christmas Island"
				},
				{
					name: "Cocos (Keeling) Islands",
					value: "Cocos (Keeling) Islands"
				},
				{ name: "Colombia", value: "Colombia" },
				{ name: "Comoros", value: "Comoros" },
				{
					name: "Congo - Brazzaville",
					value: "Congo - Brazzaville"
				},
				{
					name: "Congo - Kinshasa",
					value: "Congo - Kinshasa"
				},
				{ name: "Cook Islands", value: "Cook Islands" },
				{ name: "Costa Rica", value: "Costa Rica" },
				{ name: "Côte d'Ivoire", value: "Côte d'Ivoire" },
				{ name: "Croatia", value: "Croatia" },
				{ name: "Cuba", value: "Cuba" },
				{ name: "Curaçao", value: "Curaçao" },
				{ name: "Cyprus", value: "Cyprus" },
				{ name: "Czechia", value: "Czechia" },
				{ name: "Denmark", value: "Denmark" },
				{ name: "Djibouti", value: "Djibouti" },
				{ name: "Dominica", value: "Dominica" },
				{
					name: "Dominican Republic",
					value: "Dominican Republic"
				},
				{ name: "Ecuador", value: "Ecuador" },
				{ name: "Egypt", value: "Egypt" },
				{ name: "El Salvador", value: "El Salvador" },
				{
					name: "Equatorial Guinea",
					value: "Equatorial Guinea"
				},
				{ name: "Eritrea", value: "Eritrea" },
				{ name: "Estonia", value: "Estonia" },
				{ name: "Ethiopia", value: "Ethiopia" },
				{
					name: "Falkland Islands",
					value: "Falkland Islands"
				},
				{ name: "Faroe Islands", value: "Faroe Islands" },
				{ name: "Fiji", value: "Fiji" },
				{ name: "Finland", value: "Finland" },
				{ name: "France", value: "France" },
				{ name: "French Guiana", value: "French Guiana" },
				{
					name: "French Polynesia",
					value: "French Polynesia"
				},
				{
					name: "French Southern Territories",
					value: "French Southern Territories"
				},
				{ name: "Gabon", value: "Gabon" },
				{ name: "Gambia", value: "Gambia" },
				{ name: "Georgia", value: "Georgia" },
				{ name: "Germany", value: "Germany" },
				{ name: "Ghana", value: "Ghana" },
				{ name: "Gibraltar", value: "Gibraltar" },
				{ name: "Greece", value: "Greece" },
				{ name: "Greenland", value: "Greenland" },
				{ name: "Grenada", value: "Grenada" },
				{ name: "Guadeloupe", value: "Guadeloupe" },
				{ name: "Guam", value: "Guam" },
				{ name: "Guatemala", value: "Guatemala" },
				{ name: "Guernsey", value: "Guernsey" },
				{ name: "Guinea", value: "Guinea" },
				{ name: "Guinea-Bissau", value: "Guinea-Bissau" },
				{ name: "Guyana", value: "Guyana" },
				{ name: "Haiti", value: "Haiti" },
				{ name: "Honduras", value: "Honduras" },
				{
					name: "Hong Kong SAR China",
					value: "Hong Kong SAR China"
				},
				{ name: "Hungary", value: "Hungary" },
				{ name: "Iceland", value: "Iceland" },
				{ name: "India", value: "India" },
				{ name: "Indonesia", value: "Indonesia" },
				{ name: "Iran", value: "Iran" },
				{ name: "Iraq", value: "Iraq" },
				{ name: "Ireland", value: "Ireland" },
				{ name: "Isle of Man", value: "Isle of Man" },
				{ name: "Israel", value: "Israel" },
				{ name: "Italy", value: "Italy" },
				{ name: "Jamaica", value: "Jamaica" },
				{ name: "Japan", value: "Japan" },
				{ name: "Jersey", value: "Jersey" },
				{ name: "Jordan", value: "Jordan" },
				{ name: "Kazakhstan", value: "Kazakhstan" },
				{ name: "Kenya", value: "Kenya" },
				{ name: "Kiribati", value: "Kiribati" },
				{ name: "Kosovo", value: "Kosovo" },
				{ name: "Kuwait", value: "Kuwait" },
				{ name: "Kyrgyzstan", value: "Kyrgyzstan" },
				{ name: "Laos", value: "Laos" },
				{ name: "Latvia", value: "Latvia" },
				{ name: "Lebanon", value: "Lebanon" },
				{ name: "Lesotho", value: "Lesotho" },
				{ name: "Liberia", value: "Liberia" },
				{ name: "Libya", value: "Libya" },
				{ name: "Liechtenstein", value: "Liechtenstein" },
				{ name: "Lithuania", value: "Lithuania" },
				{ name: "Luxembourg", value: "Luxembourg" },
				{ name: "Macau SAR China", value: "Macau SAR China" },
				{ name: "Macedonia", value: "Macedonia" },
				{ name: "Madagascar", value: "Madagascar" },
				{ name: "Malawi", value: "Malawi" },
				{ name: "Malaysia", value: "Malaysia" },
				{ name: "Maldives", value: "Maldives" },
				{ name: "Mali", value: "Mali" },
				{ name: "Malta", value: "Malta" },
				{
					name: "Marshall Islands",
					value: "Marshall Islands"
				},
				{ name: "Martinique", value: "Martinique" },
				{ name: "Mauritania", value: "Mauritania" },
				{ name: "Mauritius", value: "Mauritius" },
				{ name: "Mayotte", value: "Mayotte" },
				{ name: "Mexico", value: "Mexico" },
				{ name: "Micronesia", value: "Micronesia" },
				{ name: "Moldova", value: "Moldova" },
				{ name: "Monaco", value: "Monaco" },
				{ name: "Mongolia", value: "Mongolia" },
				{ name: "Montenegro", value: "Montenegro" },
				{ name: "Montserrat", value: "Montserrat" },
				{ name: "Morocco", value: "Morocco" },
				{ name: "Mozambique", value: "Mozambique" },
				{ name: "Myanmar (Burma)", value: "Myanmar (Burma)" },
				{ name: "Namibia", value: "Namibia" },
				{ name: "Nauru", value: "Nauru" },
				{ name: "Nepal", value: "Nepal" },
				{ name: "Netherlands", value: "Netherlands" },
				{ name: "New Caledonia", value: "New Caledonia" },
				{ name: "New Zealand", value: "New Zealand" },
				{ name: "Nicaragua", value: "Nicaragua" },
				{ name: "Niger", value: "Niger" },
				{ name: "Nigeria", value: "Nigeria" },
				{ name: "Niue", value: "Niue" },
				{ name: "Norfolk Island", value: "Norfolk Island" },
				{
					name: "Northern Mariana Islands",
					value: "Northern Mariana Islands"
				},
				{ name: "North Korea", value: "North Korea" },
				{ name: "Norway", value: "Norway" },
				{ name: "Oman", value: "Oman" },
				{ name: "Pakistan", value: "Pakistan" },
				{ name: "Palau", value: "Palau" },
				{
					name: "Palestinian Territories",
					value: "Palestinian Territories"
				},
				{ name: "Panama", value: "Panama" },
				{
					name: "Papua New Guinea",
					value: "Papua New Guinea"
				},
				{ name: "Paraguay", value: "Paraguay" },
				{ name: "Peru", value: "Peru" },
				{ name: "Philippines", value: "Philippines" },
				{
					name: "Pitcairn Islands",
					value: "Pitcairn Islands"
				},
				{ name: "Poland", value: "Poland" },
				{ name: "Portugal", value: "Portugal" },
				{ name: "Puerto Rico", value: "Puerto Rico" },
				{ name: "Qatar", value: "Qatar" },
				{ name: "Réunion", value: "Réunion" },
				{ name: "Romania", value: "Romania" },
				{ name: "Russia", value: "Russia" },
				{ name: "Rwanda", value: "Rwanda" },
				{ name: "Samoa", value: "Samoa" },
				{ name: "San Marino", value: "San Marino" },
				{
					name: "São Tomé & Príncipe",
					value: "São Tomé & Príncipe"
				},
				{ name: "Saudi Arabia", value: "Saudi Arabia" },
				{ name: "Senegal", value: "Senegal" },
				{ name: "Serbia", value: "Serbia" },
				{ name: "Seychelles", value: "Seychelles" },
				{ name: "Sierra Leone", value: "Sierra Leone" },
				{ name: "Singapore", value: "Singapore" },
				{ name: "Sint Maarten", value: "Sint Maarten" },
				{ name: "Slovakia", value: "Slovakia" },
				{ name: "Slovenia", value: "Slovenia" },
				{ name: "Solomon Islands", value: "Solomon Islands" },
				{ name: "Somalia", value: "Somalia" },
				{ name: "South Africa", value: "South Africa" },
				{
					name: "South Georgia & South Sandwich Islands",
					value: "South Georgia & South Sandwich Islands"
				},
				{ name: "South Korea", value: "South Korea" },
				{ name: "South Sudan", value: "South Sudan" },
				{ name: "Spain", value: "Spain" },
				{ name: "Sri Lanka", value: "Sri Lanka" },
				{ name: "St. Barthélemy", value: "St. Barthélemy" },
				{ name: "St. Helena", value: "St. Helena" },
				{
					name: "St. Kitts & Nevis",
					value: "St. Kitts & Nevis"
				},
				{ name: "St. Lucia", value: "St. Lucia" },
				{ name: "St. Martin", value: "St. Martin" },
				{
					name: "St. Pierre & Miquelon",
					value: "St. Pierre & Miquelon"
				},
				{
					name: "St. Vincent & Grenadines",
					value: "St. Vincent & Grenadines"
				},
				{ name: "Sudan", value: "Sudan" },
				{ name: "Surivalue", value: "Surivalue" },
				{
					name: "Svalbard & Jan Mayen",
					value: "Svalbard & Jan Mayen"
				},
				{ name: "Swaziland", value: "Swaziland" },
				{ name: "Sweden", value: "Sweden" },
				{ name: "Switzerland", value: "Switzerland" },
				{ name: "Syria", value: "Syria" },
				{ name: "Taiwan", value: "Taiwan" },
				{ name: "Tajikistan", value: "Tajikistan" },
				{ name: "Tanzania", value: "Tanzania" },
				{ name: "Thailand", value: "Thailand" },
				{ name: "Timor-Leste", value: "Timor-Leste" },
				{ name: "Togo", value: "Togo" },
				{ name: "Tokelau", value: "Tokelau" },
				{ name: "Tonga", value: "Tonga" },
				{
					name: "Trinidad & Tobago",
					value: "Trinidad & Tobago"
				},
				{ name: "Tunisia", value: "Tunisia" },
				{ name: "Turkey", value: "Turkey" },
				{ name: "Turkmenistan", value: "Turkmenistan" },
				{
					name: "Turks & Caicos Islands",
					value: "Turks & Caicos Islands"
				},
				{ name: "Tuvalu", value: "Tuvalu" },
				{ name: "Uganda", value: "Uganda" },
				{ name: "Ukraine", value: "Ukraine" },
				{
					name: "United Arab Emirates",
					value: "United Arab Emirates"
				},
				{ name: "United Kingdom", value: "United Kingdom" },
				{ name: "United States", value: "United States" },
				{
					name: "United States Outlying Islands",
					value: "United States Outlying Islands"
				},
				{
					name: "United States Virgin Islands",
					value: "United States Virgin Islands"
				},
				{ name: "Uruguay", value: "Uruguay" },
				{ name: "Uzbekistan", value: "Uzbekistan" },
				{ name: "Vanuatu", value: "Vanuatu" },
				{ name: "Vatican City", value: "Vatican City" },
				{ name: "Venezuela", value: "Venezuela" },
				{ name: "Vietnam", value: "Vietnam" },
				{ name: "Wallis & Futuna", value: "Wallis & Futuna" },
				{ name: "Western Sahara", value: "Western Sahara" },
				{ name: "Yemen", value: "Yemen" },
				{ name: "Zambia", value: "Zambia" },
				{ name: "Zimbabwe", value: "Zimbabwe" }
			],

			currencies: [
				{
					name: "AED",
					value: "AED"
				},
				{
					name: "AUD",
					value: "AUD"
				},
				{
					name: "BND",
					value: "BND"
				},
				{
					name: "EUR",
					value: "EUR"
				},
				{
					name: "IDR",
					value: "IDR"
				},
				{
					name: "INR",
					value: "INR"
				},
				{
					name: "KRW",
					value: "KRW"
				},
				{
					name: "LKR",
					value: "LKR"
				},
				{
					name: "MUR",
					value: "MUR"
				},
				{
					name: "MYR",
					value: "MYR"
				},
				{
					name: "PHP",
					value: "PHP"
				},
				{
					name: "PKR",
					value: "PKR"
				},
				{
					name: "QAR",
					value: "QAR"
				},
				{
					name: "SAR",
					value: "SAR"
				},
				{
					name: "SGD",
					value: "SGD"
				},
				{
					name: "THB",
					value: "THB"
				},
				{
					name: "USD",
					value: "USD"
				},
				{
					name: "TWD",
					value: "TWD"
				},
				{
					name: "CNY",
					value: "CNY"
				},
				{
					name: "JPY",
					value: "JPY"
				},
				{
					name: "OMR",
					value: "OMR"
				},
				{
					name: "HKD",
					value: "HKD"
				},
				{
					name: "GBP",
					value: "GBP"
				}
			]
		}
	},

	computed: {
		schemaHolder() {
			return [
				{
					label: "Select Policy Owner",
					component: "entitySelect",
					entity: "case.holder",
					bindTo: "case.holder",
					props: {
						allowedEntityTypes: ["company"]
					}
				},
				{
					label: "Business activity",
					component: "entityField",
					entity: "case.holder",
					fieldToUpdate: "natureOfBusiness",
					props: {
						updateOptions: {
							componentObject: { source: BerkleyNatureOfBusinessSelect }
						}
					}
				}
			]
		},

		schemaInsured() {
			return [
				{
					label: "Select Insured Object",
					component: "entitySelect",
					bindTo: "case.insureds[0]",
					entity: "case.insureds[0]",
					props: {
						allowedEntityTypes: ["object"]
					}
				},
				// {
				// 	label: "Manage Relationship With Policy Owner",
				// 	component: "entityRelationship",
				// 	entity: "case.holder",
				// 	relation: "case.holder.relationships",
				// 	bindTo: "case.facts.insured0RelationshipId"
				// },
				{
					label: "NAIC Code",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					props: {
						suggest: {
							typeIs: "naicCode"
						},
						createOptions: {
							type: "naicCode",
							dataType: "object",
							value: {
								componentObject: {
									source: BerkleyNaicSelect, // component as vue js object
									upsertFieldOn: "input" // on what event CaseForm should call API to upsert field either input or blur
								}
							}
						}
					},
					bindTo: "case.facts.insured0NaicCodeId"
				}
			]
		},

		schemaOffer() {
			return [
				{
					label: "Start date ",
					component: "date",
					dataType: "date",
					bindTo: "offer.startDate",
					props: {
						minDate: dayjs()
							.subtract(30, "days")
							.toDate()
					}
				},
				// TODO: condition: preselect startDate + 365 days max
				{
					label: "End Date",
					component: "date",
					dataType: "date",
					bindTo: "offer.endDate"
				},
				{
					label: "Graile Policy Number",
					component: "text",
					bindTo: "offer.policyNumber"
				}
			]
		},

		schemaUnderwriter() {
			return [
				{
					label: "Underwriter",
					bindTo: "case.facts.underwriter",
					dataType: "object",
					componentObject: {
						source: BerkleyUnderwriter,
						upsertFieldOn: "input"
					}
				}
			]
		},

		schemaSubjectivity() {
			return [
				{
					label:
						"1) Receipt and Satisfactory Review of Signed and Dated Completed Proposal Form prior to binding",
					component: "toggle",
					dataType: "boolean",
					bindTo: "case.facts.satisfactoryReview",
					defaultValue: false
				},
				{
					label:
						"2)	Warranted that all products insured are complied with statutory requirement and other mandatory and / or voluntary industrial / safety standards of importing countries",
					component: "toggle",
					dataType: "boolean",
					bindTo: "case.facts.compliedWithRequirement",
					defaultValue: false
				},
				{
					label: "3) Clean Claim/Loss record for the past 5 years",
					component: "toggle",
					dataType: "boolean",
					bindTo: "case.facts.cleanClaimLossRecord",
					defaultValue: false
				}
			]
		}
	}
}
</script>
